module.exports = __webpack_public_path__ + "img/57600.d8ba8972.jpg";